import { STATUTS_COMMANDE } from "@/utils/statut-commande";

export const monCompteCommandeOverviewProps = () => ({
  commande: {
    type: Object,
    required: true
  }
})

export const useMonCompteCommandeOverview = (props) => {
  const badgeVariant = computed(() => {
    switch (props.commande.attributes.statut_code) {
      case STATUTS_COMMANDE.commandee:
        return "warning";
      case STATUTS_COMMANDE.retiree:
        return "success";
      default:
        return "danger";
    }
  })
  const isLDD = computed(() => {
    return props.commande.attributes.code_type_commande === "LDD";
  })

  return {
    badgeVariant,
    isLDD
  }
}